module.exports = __webpack_public_path__ + "images/avatars/female/1.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatars/female/1.png
// module id = LaVb
// module chunks = 55